export default __webpack_public_path__ + "static/media/No Wires_0.1.0_x64.f855ba83.msi";